import { useEffect, useState, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { apiFetch } from '../lib/api';

export default function PlatformAdminGuard({ children }: { children: ReactNode }) {
  const token = localStorage.getItem('blueprint_token');
  const [status, setStatus] = useState<'loading' | 'allowed' | 'denied'>(() =>
    token ? 'loading' : 'denied'
  );

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    apiFetch('/api/admin/partners')
      .then(() => { if (!cancelled) setStatus('allowed'); })
      .catch(() => { if (!cancelled) setStatus('denied'); });
    return () => { cancelled = true; };
  }, [token]);

  if (status === 'loading') return null;
  if (status === 'denied') return <Navigate to={token ? '/dashboard' : '/login'} replace />;
  return <>{children}</>;
}
